import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useBreakageEntitlement } from "hooks/useBreakageEntitlement";
import { BreakageAccessGate } from "config/routes/breakage-access-gate";

const RequireBreakageAccess = ({ children, login }) => {
  const navigate = useNavigate();
  const identityKey = login?.user?.id ?? login?.user?.email ?? null;
  const entitlement = useBreakageEntitlement(login?.company?.id, {
    identityKey,
  });

  return (
    <BreakageAccessGate
      loading={entitlement.loading}
      enabled={entitlement.enabled}
      unavailable={entitlement.unavailable}
      unauthorized={entitlement.unauthorized}
      forbidden={entitlement.forbidden}
      scopeMismatch={entitlement.scopeMismatch}
      error={entitlement.error}
      onReload={entitlement.reload}
      onGoHome={() => navigate("/home")}
    >
      {children}
    </BreakageAccessGate>
  );
};

const mapStateToProps = (state) => ({
  login: state.authReducer.loginReducer,
});

export default connect(mapStateToProps)(RequireBreakageAccess);
